"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderShippingPrice = void 0;
var react_1 = __importStar(require("react"));
var client_1 = require("@apollo/client");
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var react_dom_1 = __importDefault(require("react-dom"));
var ShippingPrice_1 = __importDefault(require("./ShippingPrice"));
var QUERY = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query ShippingPriceLoaderQuery(\n    $sellerProductModelIds: String\n    $prefectureCode: String\n    $quantities: String\n  ) {\n    calculateShippingPrice {\n      calculateShippingPrice(\n        sellerProductModelIds: $sellerProductModelIds\n        prefectureCode: $prefectureCode\n        quantities: $quantities\n      ) {\n        itemShippingPrices {\n          sellerProductModelId\n          shippingPrice\n        }\n        totalShippingPrice\n      }\n    }\n  }\n"], ["\n  query ShippingPriceLoaderQuery(\n    $sellerProductModelIds: String\n    $prefectureCode: String\n    $quantities: String\n  ) {\n    calculateShippingPrice {\n      calculateShippingPrice(\n        sellerProductModelIds: $sellerProductModelIds\n        prefectureCode: $prefectureCode\n        quantities: $quantities\n      ) {\n        itemShippingPrices {\n          sellerProductModelId\n          shippingPrice\n        }\n        totalShippingPrice\n      }\n    }\n  }\n"])));
var ShippingPriceLoader = function (props) {
    var _a = __read(react_1.useState(props.prefectureCode), 2), prefectureCode = _a[0], setPrefectureCode = _a[1];
    var _b = __read(react_1.useState(props.quantities), 2), quantities = _b[0], setQuantities = _b[1];
    var _c = client_1.useQuery(QUERY, {
        variables: {
            sellerProductModelIds: props.modelIds,
            prefectureCode: prefectureCode,
            quantities: quantities,
        },
    }), loading = _c.loading, error = _c.error, data = _c.data, refetch = _c.refetch, fetchMore = _c.fetchMore;
    react_1.useEffect(function () {
        if (data) {
            updateCartTotal();
        }
    }, [data]);
    var getTotalShippingPrice = function () {
        if (data && data.calculateShippingPrice && data.calculateShippingPrice.calculateShippingPrice) {
            return data.calculateShippingPrice.calculateShippingPrice.totalShippingPrice;
        }
        else {
            return 0;
        }
    };
    var numberWithCommas = function (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };
    var updateCartTotal = function () {
        // mp-web https://order.test.aperza.com/cart (to update total)
        var totalPriceNoShippingFee = document.getElementById('cart-totalPriceNoShippingFee');
        if (totalPriceNoShippingFee) {
            totalPriceNoShippingFee = parseInt(totalPriceNoShippingFee.textContent, 10);
            // smartphone + pc uses same class with different elements, update all
            var totalPrices = document.getElementsByClassName('cart-totalPriceWithShippingFee');
            for (var i = 0; i < totalPrices.length; i++) {
                var totalPrice = totalPrices.item(i);
                if (totalPrice) {
                    totalPrice.textContent =
                        '¥' + numberWithCommas(getTotalShippingPrice() + totalPriceNoShippingFee);
                }
            }
        }
    };
    var handlePrefectureChange = function (e) {
        setPrefectureCode(e.target.value);
    };
    var handleQuantityChange = function (e) {
        console.log('Handling quantity change', e.target.value);
        setQuantities(e.target.value);
    };
    react_1.useEffect(function () {
        if (document.getElementById('aperza-prefectures-for-shipping-price-component')) {
            var el = document.getElementById('aperza-prefectures-for-shipping-price-component');
            if (el) {
                el.addEventListener('change', handlePrefectureChange, false);
            }
        }
        if (document.getElementById('aperza-quantity-for-shipping-price-component')) {
            var el = document.getElementById('aperza-quantity-for-shipping-price-component');
            if (el) {
                el.addEventListener('change', handleQuantityChange, false);
            }
        }
        // if there are prefecture-class present, register those too
        var prefectureSelects = document.getElementsByClassName('aperza-prefectures-for-shipping-price-component-class');
        if (prefectureSelects && prefectureSelects !== 0) {
            for (var i_1 = 0; i_1 < prefectureSelects.length; i_1++) {
                var prefectureSelect = prefectureSelects.item(i_1);
                prefectureSelect.addEventListener('change', handlePrefectureChange, false);
            }
        }
        // if there are quantity-class present, register those too
        var quantitySelects = document.getElementsByClassName('aperza-quantity-for-shipping-price-component-class');
        if (quantitySelects && quantitySelects !== 0) {
            for (var i = 0; i < quantitySelects.length; i++) {
                var quantitySelect = quantitySelects.item(i);
                quantitySelect.addEventListener('change', handleQuantityChange, false);
            }
        }
        updateCartTotal();
        return function () {
            if (document.getElementById('aperza-prefectures-for-shipping-price-component')) {
                document.removeEventListener('change', handlePrefectureChange, false);
            }
            if (document.getElementById('aperza-quantity-for-shipping-price-component')) {
                document.removeEventListener('change', handleQuantityChange, false);
            }
            var prefectureSelects = document.getElementsByClassName('aperza-prefectures-for-shipping-price-component-class');
            if (prefectureSelects && prefectureSelects !== 0) {
                for (var i = 0; i < prefectureSelects.length; i++) {
                    var prefectureSelect = prefectureSelects.item(i);
                    prefectureSelect.removeEventListener('change', handlePrefectureChange, false);
                }
            }
            var quantitySelects = document.getElementsByClassName('aperza-quantity-for-shipping-price-component-class');
            if (quantitySelects && quantitySelects !== 0) {
                for (var i = 0; i < quantitySelects.length; i++) {
                    var quantitySelect = quantitySelects.item(i);
                    quantitySelect.removeEventListener('change', handleQuantityChange, false);
                }
            }
        };
    }, []);
    react_1.useEffect(function () {
        refetch({
            sellerProductModelIds: props.modelIds,
            prefectureCode: prefectureCode,
            quantities: quantities,
        });
    }, [prefectureCode, quantities]);
    if (loading)
        return react_1.default.createElement("div", null, "Loading");
    if (error)
        return react_1.default.createElement("div", null, error.message);
    if (!data ||
        !data.calculateShippingPrice ||
        !data.calculateShippingPrice.calculateShippingPrice) {
        console.log('Data is empty, not returning any shipping prices');
        return null;
    }
    if (!props.modelIds || !prefectureCode || !quantities) {
        console.log('Missing modelId/prefectureCode/quantity, not processing', {
            modelIds: props.modelIds,
            prefectureCode: prefectureCode,
            quantities: quantities,
        });
        return null;
    }
    return react_1.default.createElement(ShippingPrice_1.default, { totalShippingPrice: getTotalShippingPrice() });
};
exports.default = ShippingPriceLoader;
var renderShippingPrice = function (apolloClient) {
    // try to search by class - in case there are multiple components in single page (ie. cart for smartphone and pc)
    var shippingPriceComponents = document.getElementsByClassName('aperza-shipping-price-component-class');
    var shippingPriceComponent = document.getElementById('aperza-shipping-price-component');
    if (shippingPriceComponents && shippingPriceComponents.length !== 0) {
        // loop through all price components
        for (var i = 0; i < shippingPriceComponents.length; i++) {
            var currentShippingPriceComponent = shippingPriceComponents.item(i);
            if (currentShippingPriceComponent) {
                var dataset = currentShippingPriceComponent.dataset;
                if (dataset) {
                    var modelIds = dataset.modelIdCsv;
                    var prefectureCode = dataset.prefectureCode;
                    var quantities = dataset.quantityCsv;
                    react_dom_1.default.render(react_1.default.createElement(client_1.ApolloProvider, { client: apolloClient },
                        react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null) },
                            react_1.default.createElement(ShippingPriceLoader, { modelIds: modelIds, prefectureCode: prefectureCode, quantities: quantities }))), currentShippingPriceComponent);
                }
            }
        }
    }
    else if (shippingPriceComponent) {
        // just look for single id
        var modelIds = shippingPriceComponent.dataset.modelIdCsv;
        var prefectureCode = shippingPriceComponent.dataset.prefectureCode;
        var quantities = shippingPriceComponent.dataset.quantityCsv;
        react_dom_1.default.render(react_1.default.createElement(client_1.ApolloProvider, { client: apolloClient },
            react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null) },
                react_1.default.createElement(ShippingPriceLoader, { modelIds: modelIds, prefectureCode: prefectureCode, quantities: quantities }))), shippingPriceComponent);
    }
};
exports.renderShippingPrice = renderShippingPrice;
var templateObject_1;
